import React from "react";

/**
 * SC — l'agence des gens
 * The "c" of SC is rendered as superscript.
 * Size scales with the parent font-size.
 */
export default function Logo({ className = "", accentClass = "text-[#FF5B24]", showTagline = true }) {
  return (
    <span className={className}>
      S
      <sup className={`text-[0.55em] font-medium align-super ${accentClass}`}>c</sup>
      {showTagline && (
        <span className="font-normal"> l'agence des gens</span>
      )}
    </span>
  );
}
